<script>
	export let name;

	$: score = Object.keys(globalState).reduce(function(accumulator, key) {
				return accumulator + globalState[key];
				}, 0);

	$: riskGroup = calculateRiskGroup(score);

	$: probability = Math.round(extractProbability(score) * 100000)/1000;

	var globalState = {
		age: 0,
		blood: 0,
	}

	function extractProbability(params)
	{
		var out;
		probabilityMap.map((obj) => {
			if(obj.escore == params)
			{
				out = obj.prob;
			}
		})
		return(out)
	}

	var probabilityMap = [
	{
		"escore": 0,
		"prob": 0.035
	},
	{
		"escore": 1,
		"prob": 0.0509
	},
	{
		"escore": 2,
		"prob": 0.0735
	},
	{
		"escore": 3,
		"prob": 0.1049
	},
	{
		"escore": 4,
		"prob": 0.1476
	},
	{
		"escore": 5,
		"prob": 0.2038
	},
	{
		"escore": 6,
		"prob": 0.2745
	},
	{
		"escore": 7,
		"prob": 0.3586
	},
	{
		"escore": 8,
		"prob": 0.4525
	},
	{
		"escore": 9,
		"prob": 0.5498
	},
	{
		"escore": 10,
		"prob": 0.6435
	},
	{
		"escore": 11,
		"prob": 0.7274
	},
	{
		"escore": 12,
		"prob": 0.7977
	},
	{
		"escore": 13,
		"prob": 0.8535
	},
	{
		"escore": 14,
		"prob": 0.896
	},
	{
		"escore": 15,
		"prob": 0.9272
	},
	{
		"escore": 16,
		"prob": 0.9495
	},
	{
		"escore": 17,
		"prob": 0.9653
	},
	{
		"escore": 18,
		"prob": 0.9762
	},
	{
		"escore": 19,
		"prob": 0.9838
	},
	{
		"escore": 20,
		"prob": 0.989
	}
	]

	function calculateRiskGroup(params)
	{
		if(params <= 1){
			return('Low')
		}
		else if(params >= 2 && params <= 4){
			return('Intermediate');
		}
		
		else if(params >= 5 && params <= 8){
			return('High');
		}
		
		else if(params >= 9){
			return('Very High');
		}
	}

	function changeGlobalState(params, value)
	{
		globalState = {...globalState, [params]: value}

		console.log(globalState)
	}
</script>

<main>
	

	<div class="container">


		<div class="row align-items-center justify-content-center mt-3">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">Age (Years)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked on:click={() => {changeGlobalState('age', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio1">{"< 60"}</label>

						<input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" on:click={() => {changeGlobalState('age', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio2">60 - 69</label>

						<input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" on:click={() => {changeGlobalState('age', 3)}}>
						<label class="btn btn-outline-primary" for="btnradio3">70 - 79</label>

						<input type="radio" class="btn-check" name="btnradio" id="btnradio4" autocomplete="off" on:click={() => {changeGlobalState('age', 5)}}>
						<label class="btn btn-outline-primary" for="btnradio4">>= 80</label>
					</div>
				</div>
				</div>
			</div>
		</div>

		<div class="row align-items-center justify-content-center">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">Blood urea nitrogen (mg/dL)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio2" id="btnradio5" autocomplete="off" checked on:click={() => {changeGlobalState('blood', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio5">{"< 42"}</label>

						<input type="radio" class="btn-check" name="btnradio2" id="btnradio6" autocomplete="off" on:click={() => {changeGlobalState('blood', 3)}}>
						<label class="btn btn-outline-primary" for="btnradio6">>= 42</label>
					</div>
				</div>
				</div>
			</div>
		</div>

		<div class="row align-items-center justify-content-center">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">	Comorbidities <span style="font-size: 14px; color: #4e4e4e;">(hypertension, diabetes mellitus, obesity, coronary artery disease, heart failure, atrial fibrillation or flutter, cirrhosis, cancer and previous stroke)</span></h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio3" id="btnradio7" autocomplete="off" checked on:click={() => {changeGlobalState('comorbidities', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio7">{"< 2"}</label>

						<input type="radio" class="btn-check" name="btnradio3" id="btnradio8" autocomplete="off" on:click={() => {changeGlobalState('comorbidities', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio8">>= 2</label>
					</div>
				</div>
				</div>
			</div>
		</div>

		<div class="row align-items-center justify-content-center">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">	C reative protein (mg/L)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio4" id="btnradio9" autocomplete="off" checked on:click={() => {changeGlobalState('creative', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio9">{"< 100"}</label>

						<input type="radio" class="btn-check" name="btnradio4" id="btnradio10" autocomplete="off" on:click={() => {changeGlobalState('creative', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio10">>= 100</label>
					</div>
				</div>
				</div>
			</div>
		</div>

		<div class="row align-items-center justify-content-center">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">	SF ratio (%)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio5" id="btnradio14" autocomplete="off" on:click={() => {changeGlobalState('sfratio', 6)}}>
						<label class="btn btn-outline-primary" for="btnradio14">{"<="} 150 </label>

						<input type="radio" class="btn-check" name="btnradio5" id="btnradio13" autocomplete="off" on:click={() => {changeGlobalState('sfratio', 3)}}>
						<label class="btn btn-outline-primary" for="btnradio13">150.1 - 235</label>
						<input type="radio" class="btn-check" name="btnradio5" id="btnradio12" autocomplete="off" on:click={() => {changeGlobalState('sfratio', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio12">235.1 - 315.0</label>
						
						
						<input type="radio" class="btn-check" name="btnradio5" id="btnradio11" autocomplete="off" checked on:click={() => {changeGlobalState('sfratio', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio11">{"> 315"}</label>
					</div>
				</div>
				</div>
			</div>
		</div>


		<div class="row align-items-center justify-content-center">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">	Platelet count (x10^9/L)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio6" id="btnradio17" autocomplete="off" on:click={() => {changeGlobalState('platet', 2)}}>
						<label class="btn btn-outline-primary" for="btnradio17">{"< 100"}</label>

						<input type="radio" class="btn-check" name="btnradio6" id="btnradio16" autocomplete="off" on:click={() => {changeGlobalState('platet', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio16">100 - 150</label>
						
						<input type="radio" class="btn-check" name="btnradio6" id="btnradio15" autocomplete="off" checked on:click={() => {changeGlobalState('platet', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio15">{"> 150"}</label>
					
					</div>
				</div>
				</div>
			</div>
		</div>


		<div class="row align-items-center justify-content-center mb-4">
			<div class="col-md-12 col-sm-12 mb-3">
				<div class="card" >
				<div class="card-body">
					<h5 class="card-title">	Heart rate (bpm)</h5>
					<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
						<input type="radio" class="btn-check" name="btnradio7" id="btnradio18" autocomplete="off" checked on:click={() => {changeGlobalState('heart', 0)}}>
						<label class="btn btn-outline-primary" for="btnradio18">{"<= 90"}</label>

						<input type="radio" class="btn-check" name="btnradio7" id="btnradio19" autocomplete="off" on:click={() => {changeGlobalState('heart', 1)}}>
						<label class="btn btn-outline-primary" for="btnradio19">91 - 130</label>
						
						<input type="radio" class="btn-check" name="btnradio7" id="btnradio20" autocomplete="off" on:click={() => {changeGlobalState('heart', 2)}}>
						<label class="btn btn-outline-primary" for="btnradio20">{">= 131"}</label>
					
					</div>
				</div>
				</div>
			</div>
		</div>
		

	
		<div class="row align-items-center justify-content-center pb-5">
			<div class="col-md-3 col-sm-12 mb-3">
				<div class="card" >
					<div class="card-body">
						<h5 class="card-title fw-light">Final Score</h5>
						<h3 class="card-title fw-bold">{ score }/20</h3>
					</div>
				</div>
			</div>
			<div class="col-md-3 col-sm-12 mb-3">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title fw-light">Risk Group</h5>
						<h3 class="card-title fw-bold ">{riskGroup}</h3>
					</div>
				</div>
			</div>
			<div class="col-md-3 col-sm-12 mb-3">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title fw-light">Predicted Mortality (%)</h5>
						<h3 class="card-title fw-bold ">{probability}%</h3>
					</div>
				</div>
			</div>
		</div>

	</div>
	

</main>

<style>
	.card {
		box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
		border: none;
	}
	.btn-outline-primary:hover {
    color: #fff;
    background-color: #629eb9;
    border-color: #629eb9;
}

	.btn-check:active+.btn-outline-primary, .btn-check:checked+.btn-outline-primary, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show, .btn-outline-primary:active {
		color: #fff;
		background-color: #4bb4e3;
		border-color: #4bb4e3;
	}
</style>